import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

import { NAVIGATION } from 'constant/config'

import { HomeRouters } from 'pages/Home/routes'
import { AccountRouters } from 'pages/Account/routes'
import ProtectedRoute from './ProtectedRoute'

const Home = lazy(() => import('pages/Home'))
// const Registration = lazy(() => import('pages/Registration'))
const Game = lazy(() => import('pages/Game'))
const Promo = lazy(() => import('pages/Promo'))
const Empty = lazy(() => import('pages/Empty'))
const Account = lazy(() => import('pages/Account'))

export const routes = [
  {
    path: '/',
    element: <Navigate to={NAVIGATION.my_casino.url} replace />,
    layout: ['header', 'main', 'footer'],
  },
  {
    path: NAVIGATION.my_casino.url,
    element: <Home />,
    children: HomeRouters,
    layout: ['header', 'main', 'footer'],
  },
  // {
  //   path: NAVIGATION.registration.url,
  //   element: <Registration />,
  //   layout: ['header', 'main', 'footer'],
  // },
  {
    path: `${NAVIGATION.game.url}/:gameId/:demo`,
    element: <Game />,
    layout: ['game'],
  },
  {
    path: `${NAVIGATION.promo.url}/:promo`,
    element: <Promo />,
    layout: ['header', 'main', 'footer'],
  },
  {
    path: NAVIGATION.account.url,
    element: (
        <ProtectedRoute>
          <Account />
        </ProtectedRoute>
    ),
    children: AccountRouters,
    layout: ['header', 'main', 'footer'],
  },
  {
    path: '*',
    element: <Empty />,
    layout: ['header', 'main', 'footer'],
  },
]
